import { render, staticRenderFns } from "./eliminarfacebook.vue?vue&type=template&id=4bb68c29&"
import script from "./eliminarfacebook.vue?vue&type=script&lang=js&"
export * from "./eliminarfacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports